import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const buildUrl = (path, params) => {
    const query = new URLSearchParams(params).toString();
    return `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${path}?${query}`;
};

export const fetchCustomerSales = async ({ from, to, dateType }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getCustomerSalesByDateRange,
        { from, to, dateType }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching customer sales:", error);
        throw error;
    }
};

export const fetchCustomerPurchases = async ({ from, to, dateType }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getCustomerPurchasesByDateRange,
        { from, to, dateType }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching customer purchases:", error);
        throw error;
    }
};

export const fetchCustomerBudgets = async ({ year, type }) => {
    if (!year) return [];
    const url = buildUrl(
        oAuthServiceConfig.getCustomerBudgets,
        { year, type }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching customer budgets:", error);
        throw error;
    }
};

export const fetchTerritoryExternalBudgets = async ({ year }) => {
    if (!year) return [];

    const url = buildUrl(
        '/api/get-territory-external-budget',
        { year }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching territory external budgets:", error);
        throw error;
    }
};

export const fetchTerritoryInternalBudgets = async ({ year }) => {
    if (!year) return [];

    const url = buildUrl(
        '/api/get-territory-budget',
        { year }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching territory internal budgets:", error);
        throw error;
    }
};

export const fetchActiveCustomers = async ({ active = true, customerType = 'REGULAR' }) => {
    const url = buildUrl(
        oAuthServiceConfig.findCompaniesByActiveAndType,
        { active, customerType }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data?._embedded?.companies || [];
    } catch (error) {
        console.error("Error fetching customers:", error);
        throw error;
    }
};

export const fetchActiveFactoryVendors = async ({ active = true }) => {
    const url = buildUrl(
        `${oAuthServiceConfig.factoryVendor}/search/findByActive`,
        { active }
    );
    try {
        const res = await OAuthService.getList(url);
        return res?.data?._embedded?.factoryVendors || [];
    } catch (error) {
        console.error("Error fetching factory vendors:", error);
        throw error;
    }
};

export const fetchActiveShowrooms = async () => {
    const url = buildUrl(
        `${oAuthServiceConfig.showrooms}/search/findByActiveTrue`,
        {}
    );
    try {
        const res = await OAuthService.getList(url);
        return res?.data?._embedded?.showrooms || [];
    } catch (error) {
        console.error("Error fetching showrooms:", error);
        throw error;
    }
};

export const fetchProjectTotals = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getProjectTotal,
        { from, to }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching project totals:", error);
        throw error;
    }
};

export const fetchAllCustomers = async ({ customerType = 'REGULAR' }) => {
    const url = buildUrl(
        `${oAuthServiceConfig.companies}/search/findByCustomerType`,
        { customerType, size: 2000 }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data?._embedded?.companies || [];
    } catch (error) {
        console.error("Error fetching all customers:", error);
        throw error;
    }
};